/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of StockCheckUomsClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfGetStockCheckUomResponse,
  UpdateStockCheckUomsRequest,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockStockCheckUoms = [
  { itemNumber: 'ITEM001', description: 'Whole Milk', stockCheckUom: 'Case', primaryUom: 'Each', conversionFactor: 12 },
  { itemNumber: 'ITEM002', description: 'White Bread', stockCheckUom: 'Each', primaryUom: 'Each', conversionFactor: 1 },
  { itemNumber: 'ITEM003', description: 'Coffee Beans', stockCheckUom: 'Kg', primaryUom: 'g', conversionFactor: 1000 },
];

/* ---- Mocked Client Implementation ---- */

import { IStockCheckUomsClient } from '../../interfaces';
export class StockCheckUomsClientMocked implements IStockCheckUomsClient {
  constructor(baseUrl?: string) {}

  async uoms(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfGetStockCheckUomResponse> {
    await delay();
    return successResponse({
      uoms: mockStockCheckUoms,
      totalCount: mockStockCheckUoms.length,
    }) as SuccessResponse_1OfGetStockCheckUomResponse;
  }

  async update(body?: UpdateStockCheckUomsRequest, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body?.stockCheckUoms) {
      body.stockCheckUoms.forEach((update) => {
        const uom = mockStockCheckUoms.find((u) => u.itemNumber === update.uom);
        if (uom) {
          uom.stockCheckUom = update.uom || uom.stockCheckUom;
        }
      });
    }
  }

  // ====== Auto-generated stub methods ======

}
